<template>
  <!-- 信用借支 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="会员账号">
          <a-input v-model="userid" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search()" v-if="role79">搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="onEdit({})" v-if="role68">提高额度</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="danger" @click="checkDelete()" v-if="role69">批量删除</a-button>
        </a-form-item>
        <a-form-item v-if = false>
          <a-button type="danger" @click="AllDelete()" v-if="role70">删除所有</a-button>
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table
      size="middle"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :columns="columns"
      row-key="ID"
      :data-source="data"
      :pagination="false"
      :loading="loading"
      bordered
    >
      <template slot="operate" slot-scope="text, record">
        <a-tooltip v-if="role68">
            <template slot="title"> 编辑 </template>
            <a href="javascript:;" @click="onEdit(record)">
              <a-icon type="edit" style="font-size: 22px"></a-icon>
            </a>
        </a-tooltip>
        <span v-if="role68"></span>
        &nbsp;
        <a-tooltip v-if="role69">
          <template slot="title"> 删除 </template>
          <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)">
            <a href="javascript:;">
              <a-icon type="delete" style="font-size: 22px"></a-icon>
            </a>
          </a-popconfirm>
        </a-tooltip>
      </template>
    </a-table>
    <div style="margin: 16px 0;height: 8px;" >
        <a-pagination style="float:right;"
        show-size-changer
        :default-current="pagination.current" 
        :total="pagination.total" 
        :show-total="total => `共 ${total} 条`" 
        :pageSizeOptions="pagination.sizeList" 
        @change="pageNumberChange"
        @showSizeChange="sizeChange"  />
    </div>
    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="新增/编辑" @ok="modalOk">
      <a-form-model
        ref="ruleForm"
        :rules="rules"
        :model="formModel"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="会员账号" ref="User" prop="User">
          <a-input v-model="formModel.User" />
        </a-form-model-item>
        <a-form-model-item label="额度" ref="Amount" prop="Amount">
          <a-input v-model.number="formModel.Amount" />
        </a-form-model-item>
        <a-form-model-item label="备注" ref="Memo" prop="Memo">
          <a-textarea
            v-model="formModel.Memo"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
import moment from "moment";
import { isSpecialStr,isNumber } from "../../js/textverify";

export default {
  data() {
    return {
      //权限68,69,70,79
      role68:false,
      role69:false,
      role70:false,
      role79:false,
      visible: false, //弹框状态
      formModel: {}, // 弹框字段
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      userid: undefined,
      data: [],
      columns: [
        {
          title: "用户名",
          dataIndex: "User",
          align: "center",
        },
        {
          title: "信用借支",
          dataIndex: "Amount",
          align: "center",
        },
        {
          title: "备注",
          dataIndex: "Memo",
          align: "center",
        },
        {
          title: "操作",
          dataIndex: "operate",
          align: "center",
          scopedSlots: { customRender: "operate" },
        },
      ],
      pagination: { current: 1, pageSize: 10, total: 0,
        sizeList:['10','20','30','40','50'],
      },
      selectedRowKeys: [],
      loading: false,
      type:1,
      rules:{
        User: [
          { required: true, message: '请输入会员账号', trigger: 'blur' },
          { min: 1, max: 20, message: '长度应该是1到20', trigger: 'blur' },
          { validator: isSpecialStr, trigger: 'change' },
        ],
        Amount: [
          { required: true, message: '请输入额度', trigger: 'blur' },
          { validator: isNumber, trigger: 'change' },
        ],
        Memo: [
          { validator: isSpecialStr, trigger: 'change' },
        ],
      }
    };
  },
  methods: {
    moment,
    //分页页数的改变
    pageNumberChange(current, size) {
      this.pagination.current = current;
      this.pagination.pageSize = size;
      this.qryListAPI();
    },
    //  分页显示条数的变化
    sizeChange(current, size) {
      this.pagination.current = current;
      this.pagination.pageSize = size;
      this.qryListAPI();
    },
    // 搜索
    search() {
      this.pagination.current = 1;
      this.qryListAPI();
    },
    // 编辑
    onEdit(data) {
      this.visible = true;
      this.formModel = {...data};
    },
    // 编辑确认
    modalOk() {
      if(this.formModel.Memo === undefined){
        this.formModel.Memo = '';
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.axios.post("/UserMember/SaveCreditAdvance", this.formModel).then((res) => {
            if (res.data) {
              this.$message.success("编辑成功");
              this.qryListAPI();
              this.visible = false;
            }
          });
        } 
      });
    },
    // 删除
    onDelete(data) {
      this.axios
        .post("/UserMember/DeleteCreditAdvance", { IDList: [{ ID: data.ID }] })
        .then((res) => {
          if (res.data) {
            this.$message.success("删除成功");
            this.qryListAPI();
          }
        });
    },
    // 勾选删除
    checkDelete() {
      if (this.selectedRowKeys.length < 1) {
        this.$message.warning("请勾选数据");
        return;
      }
      const that = this;
      this.$confirm({
        title: "批量删除",
        content: "您要确定要删除勾选数据吗?",
        onOk() {
          const idList = [];
          that.selectedRowKeys.forEach((element) => {
            idList.push({ ID: element });
          });
          that.axios
            .post("/UserMember/DeleteCreditAdvance", {
              IDList: idList,
            })
            .then((res) => {
              if (res.data) {
                that.$message.success("删除成功");
                that.qryListAPI();
              }
            });
        },
      });
    },
    // 删除所有
    AllDelete() {
      const that = this;
      this.$confirm({
        title: "批量删除",
        content: "您要确定要删除所有吗?",
        onOk() {
          that.axios
            .post("/usermember/alldeletecreditadvance", {})
            .then((res) => {
              if (res.data) {
                that.$message.success("删除成功");
                that.qryListAPI();
              }
            });
        },
      });
    },
    // 查询API
    qryListAPI() {
      this.loading = true;
      this.axios
        .post("/UserMember/GetCreditAdvanceList", {
          UserID: this.userid == undefined ? "" : this.userid,
          pageindex: this.pagination.current,
          pagesize: this.pagination.pageSize,
        })
        .then((res) => {
          if (res.data) {
            this.pagination.total = res.total;
            this.loading = false;
            this.data = res.data;
          }
        });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
  },
  watch: {
    '$route' (to, from) {
      if(this.$route.params.name === "creditadvance"){
        this.userid = this.$route.params.userid;
        this.qryListAPI();
      }
    }
  },
  //首次加载
  created() {
    if(this.$route.params.name === "creditadvance"){
      this.userid = this.$route.params.userid;
    }
    this.qryListAPI();
    const array = JSON.parse(sessionStorage.RoleID);
    const roleID = [68,69,70,79];
    var isRole = roleID.filter(function(item){
      return array.indexOf(item) != -1
    });
    //功能权限获取
    isRole.forEach(element => {
      this["role" + element] = true;
    });
    
  }
};
</script>

<style>
.red {
  color: rgb(255, 0, 0);
}
.marr10 {
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/usermanage/creditadvance.vue